import messageMutations from './mutations.js';
import messageActions from './actions.js';
import messageGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            sharedmessagestatus: 'pending',
            sharedmessages: {}
        }
    },
    mutations: messageMutations,
    actions: messageActions,
    getters: messageGetters
};
